import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import NoEncryptionIcon from '@mui/icons-material/NoEncryption'

import CircularGaugeIcon from '../CircularGaugeIcon'
import FieldRow from './FieldRow'

const LockStatusField = ({ isLocked }) => (
  <FieldRow
    icon={
      <CircularGaugeIcon
        Icon={isLocked === true ? LockIcon : isLocked === false ? LockOpenIcon : NoEncryptionIcon}
        thresholds={[
          { limit: 0.5, color: '#ed6c02', label: 'state.lock.unlocked' },
          { limit: Infinity, color: '#1fd92e', label: 'state.lock.locked' },
        ]}
        value={isLocked == null ? null : isLocked ? 1 : 0}
      />
    }
  />
)

export default LockStatusField
